import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Footer, Image } from '@outdoor-voices/ui';
import { useMutation, useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ShopBlocks, { SHOP_BLOCKS } from '@outdoor-voices/ui/dist/components/ShopBlocks';
import { createReview, getProduct, getVariant } from './queries';
import { OV_EMS_CDN } from '../../config/theme';
import Form from './Form';
import Submitted from './Submitted';
import css from './SubmitAReview.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

var SubmitAReview = function SubmitAReview(_ref) {
  var loadingHTML = _ref.loadingHTML,
      shopifyId = _ref.shopifyId,
      variantId = _ref.variantId;
  // Get product if variant not available
  var loadingVariant = variantId !== false && variantId !== undefined;
  var query = loadingVariant ? getVariant : getProduct;
  var variables = {
    shopifyId: loadingVariant ? variantId : shopifyId
  }; // Query for variant or product info

  var CUSTOMER = window.OV.CUSTOMER;

  var _useQuery = useQuery({
    query: query,
    variables: variables
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      fetching = _useQuery2$.fetching,
      data = _useQuery2$.data,
      error = _useQuery2$.error;

  var _useState = useState(CUSTOMER.loggedIn ? CUSTOMER.name.split(' ')[0] : ''),
      _useState2 = _slicedToArray(_useState, 2),
      name = _useState2[0],
      setName = _useState2[1];

  var _useMutation = useMutation(createReview),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      resReview = _useMutation2[0],
      executeReview = _useMutation2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      submitted = _useState4[0],
      setSubmitted = _useState4[1]; // Scroll back to the top of the page once a review has been submitted


  useEffect(function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [submitted]); // Display while loading

  if (fetching) {
    return /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: loadingHTML
      }
    });
  } // Return if error in query


  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsxs("div", {
      className: css.errorRoot,
      "data-testid": "error",
      children: [/*#__PURE__*/_jsx("h2", {
        children: "Oops...Something went wrong."
      }), /*#__PURE__*/_jsx("p", {
        className: css.details,
        children: error.message
      })]
    });
  } // Get product


  var product = loadingVariant ? data.variant.product : data.product;
  var sizePurchased = loadingVariant ? data.variant.variantStack.size : ''; // Display if product isn't available for review

  if (!product || !product.properties.reviewable) {
    SHOP_BLOCKS[0].cta.href = '/collections/bestsellers?genderFilter=woman';
    SHOP_BLOCKS[0].image.right = true;
    SHOP_BLOCKS[1].cta.href = '/collections/bestsellers?genderFilter=man';
    SHOP_BLOCKS[1].image.left = true;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: css.errorRoot,
        children: [/*#__PURE__*/_jsx("h2", {
          className: css.errorTitle,
          children: "404 Not Found"
        }), /*#__PURE__*/_jsx("p", {
          className: css.details,
          children: "Sorry, that product is no longer available for review."
        })]
      }), /*#__PURE__*/_jsx(ShopBlocks, {
        blocks: SHOP_BLOCKS
      }), /*#__PURE__*/_jsx("div", {
        className: css.footer,
        children: /*#__PURE__*/_jsx(Footer, {
          shopURL: "/"
        })
      })]
    });
  } // Get product properties


  var absoluteUrl = product.absoluteUrl,
      colorways = product.colorways,
      title = product.title,
      productType = product.productType;
  var colorway = loadingVariant ? data.variant.colorway : colorways.edges[0].node;
  var assets = colorway.assets,
      sizes = colorway.sizes;
  var hasAssets = assets.length !== 0; // Get review title

  var reviewTitle = !absoluteUrl ? title : /*#__PURE__*/_jsx("a", {
    "aria-label": "Go Back To ".concat(title),
    className: css.title,
    href: absoluteUrl,
    children: title
  });
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, _defineProperty({}, css.padded, !submitted)]),
    children: [!submitted && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: css.header,
        children: [/*#__PURE__*/_jsx("span", {
          className: css.subtitle,
          children: "Write a review for:"
        }), /*#__PURE__*/_jsx("h1", {
          className: css.title,
          children: reviewTitle
        }), /*#__PURE__*/_jsxs("div", {
          className: css.points,
          children: [/*#__PURE__*/_jsx("div", {
            "aria-hidden": "true",
            className: css.pointsStar,
            role: "presentation",
            children: /*#__PURE__*/_jsx(Image, {
              alt: "A Star",
              height: 48,
              sizes: [48],
              src: "".concat(OV_EMS_CDN, "loyalty/icons/star.png"),
              width: 48,
              wrap: false
            })
          }), /*#__PURE__*/_jsx("div", {
            children: "Earn 25 points with OV Rewards when you write a review and an additional 25 points when you add a photo of your gear. Win-win."
          })]
        }), hasAssets && /*#__PURE__*/_jsx("div", {
          className: css.productImages,
          children: assets.edges.map(function (_ref3) {
            var node = _ref3.node;
            return /*#__PURE__*/_createElement(Image, _objectSpread(_objectSpread({}, node.image), {}, {
              key: node.id,
              sizes: [180, 320, 630]
            }));
          })
        })]
      }), /*#__PURE__*/_jsx(Form, {
        executeReview: executeReview,
        id: product.id,
        productType: productType,
        resReview: resReview,
        setName: setName,
        setSubmitted: setSubmitted,
        sizePurchased: sizePurchased,
        sizes: sizes
      })]
    }), submitted && /*#__PURE__*/_jsx(Submitted, {
      name: name,
      productName: title
    })]
  });
};

SubmitAReview.defaultProps = {
  variantId: false
};
SubmitAReview.propTypes = {
  loadingHTML: PropTypes.string,
  shopifyId: PropTypes.string.isRequired,
  variantId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default SubmitAReview;